export const USER_COUPONS_PROMOS = 'coupons'
